import * as React from "react";
import { DatePicker } from "../../../../../../react-core/Datepicker/DatePicker";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { MoneyHelper } from "../../../../../Shared/Common/MoneyHelper";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { MoneyTextBoxEditor } from "../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { NumberTextBoxEditor } from "../../../../../../react-core/Html/NumberTextBoxEditor";
import { PercentageTextBoxEditor } from "../../../../../../react-core/Html/PercentageTextBoxEditor";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { addDays } from "../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SecurityType } from "../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { OrderType } from "../../../../../../Wrap/Constants/Enums/Domain/OrderType";
import { ProductType } from "../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { ServiceProposition } from "../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { Instrument } from "../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { Investment } from "../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { ContentDatePicker } from "../../../../../Shared/Entities/Constants/DateConstants";
import { InvestmentSelectionAction } from "../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { UnderlyingTable } from "../../../../../Shared/IST/Components/Shared/UnderlyingTable";
import { ProcessType, GBPInvestmentCode } from "../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { TableHeader } from "../../../../../Shared/Table/Components/TableHeader";
import { TableRow } from "../../../../../Shared/Table/Components/TableRow";
import { ITableConfig, Table } from "../../../../../Shared/Table/Table";
import AriaTooltip from "../../../../../Shared/Tooltip/AriaTooltip";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ClientAccountStore } from "../../../../Stroes/Variable";
import { InvestmentDetailsPopupModal } from "../InvestmentDetailsPopUp/InvestmentDetailsPopupModal";
import { sellAllTooltip } from "../../Sell/Resource/Content";
import { treasureAssetTooltip, fundAllocationTooltip } from "../../Sell/Resource/Content";
import { orderAmendedMsg } from "../../Switch/Resource/Content";
import { SubAccountTypeHelper } from "../Helpers/SubAccountTypeHelper";
import { datePickerOptions, processTypeEnum } from "../Resource/Contents";
import { TreasuredAssetsStore } from "../../../../../../applications/Dashboard/Stroes/Variable";
import { disableInput } from "./BuySellAllocationTableHelper";
import { DepositProductsQuery } from "../../../../../../Wrap/Models/Domains/Investment/DepositProductsQuery";
import { DepositSearchResults } from "../../../../../Shared/IST/Components/Deposits/DepositSearchResult";
import { DepositProduct } from "../../../../../../Wrap/Models/Domains/Investment/DepositProduct";
import { BatchType } from "../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { InvestmentsAction } from "../../PortfolioDashboard/Components/Investment/Action/InvestmentAction";

interface IBuySellAllocationTableProps extends IProcessComponentProps {
    process: ProcessType;
    orderType: OrderType;
    totalValue: number;
    onToggle: (isToggle, index, row) => void;
    excludeLimit?: boolean;
    onTreasuredAssetChange: Function;
    ChecktreasuredAsset: Array<number>;
    depositProducts: Record<number, DepositProduct>;
    batchType: BatchType;
}

interface IBuySellAllocationTableState {
    code: string;
    selectedInvestment: Investment;
    isShowDetailModal: boolean;
    showOrderAmendedMessage: number[];
    maxInvestmentInitial: number;
    minInvestmentInitial: number;
}

export class BuySellAllocationTable extends ProcessComponent<
    IBuySellAllocationTableProps,
    IBuySellAllocationTableState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            code: null,
            selectedInvestment: null,
            isShowDetailModal: false,
            showOrderAmendedMessage: [],
            maxInvestmentInitial: 0,
            minInvestmentInitial: 0
        };
    }

    componentDidUpdate(prevProps: IBuySellAllocationTableProps) {
        super.componentDidUpdate(prevProps);
        if (prevProps.orderType !== this.props.orderType) {
            this.setState({ showOrderAmendedMessage: [] });
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    isValid() {
        const flag = super.isValid();
        const total = this.props.data.reduce(
            (sum, curr) => (sum = sum + (curr.OrderValue ? Number(Number(curr.OrderValue).toFixed(2)) : 0)),
            0
        );

        const totalPrecentage = this.props.data.reduce(
            (sum, curr) => (sum = sum + (curr.OrderPercentage ? Number(Number(curr.OrderPercentage).toFixed(2)) : 0)),
            0
        );

        let matchTotalValue = this.props.data && Number(total.toFixed(2)) == this.props.totalValue;
        if (this.props.orderType == OrderType.Percentage && this.props.process == ProcessType.Buy) {
            matchTotalValue = Number(totalPrecentage.toFixed(2)) == 100;
        }
        if (!matchTotalValue) {
            this.props.showErrorMsgPopUp(["Price of investments not matching the total value"]);
        }
        return flag && matchTotalValue;
    }

    private getOrderType = (row) => {
        
        if(row.isSellAll){
            return OrderType.Quantity;
        } else if (!(row.Type === undefined || row.Type === null)) {
            return row.Type;
        } else {
            return this.props.orderType;
        }
    }

    private onChangeInvestment = (changes, InstrumentCode, shouldUncheckEvenWeight = false) => {
        const _data: any[] = this.props.data.concat();
        const index = _data.findIndex((ele) => ele.InstrumentCode == InstrumentCode);
        if (index < 0) return _data;
        if (changes == -1) {
            _data.splice(index, 1);
        } else {
            const obj = _data[index];
            for (const key in changes) {
                obj[key] = changes[key];
            }
            _data[index] = obj;
        }
        this.props.onChange(_data, shouldUncheckEvenWeight);
    };

    private disableSell = (row) => {
        const hasOpenSellOrders: boolean = !this.isCashProduct(row) &&
            (row.Instrument.HasOpenValueSellOrder || row.Instrument.SellOrders > 0);

        return (
            this.isSellOrSwitchFrom(this.props.process) &&
            (hasOpenSellOrders ||
                !row.tradeable ||
                row.Instrument.CurrQuantity <= 0 ||
                (this.isCashProduct(row) && this.props.batchType === BatchType.Standing))
        );
    };

    private isSellOrSwitchFrom(processType: ProcessType) {
        return processType == ProcessType.Sell || processType == ProcessType.SwitchFrom;
    }

    private sellAll = (v: boolean, code) => {
        const _data: any[] = this.props.data.concat();
        const ele = _data.find((ele) => ele.InstrumentCode == code);
        this.onChangeInvestment(
            {
                OrderValue: v ? ele.Instrument.MarketValue.Amount : null,
                OrderQuantity: v ? ele.Instrument.CurrQuantity : null,
                OrderPercentage: v ? 100 : null,
                isSellAll: v,
                Type: v ? OrderType.Quantity : this.props.orderType,
            },
            code
        );
    };

    private isCashProduct = (row): boolean =>
    {
        return row.Instrument.Type === ProductType.CashProduct;
    }

    private treasureAsset = (v: boolean, code) => {
        const _data: any[] = this.props.data.concat();
        const ele = _data.find((ele) => ele.InstrumentCode == code);

        this.props.onTreasuredAssetChange(v, ele.Instrument.ProductId);
    };

    private targetAllocationTable = (data) => {
        const col = [
            {
                title: "Underlying investments",
                key: "Name",
                render: (data, row, index) => {
                    if (data == "GBP Cash") return data;
                    return (
                        <a className="hyperlink" onClick={() => this.onInvestmentSelected(row, row.UnitCost)}>
                            {data}
                        </a>
                    );
                },
            },
            {
                title: "Target allocation",
                key: "targetAllocation",
            },
        ];
        return (
            <div className="te-subwrap">
                <Table col={col} data={data} />
            </div>
        );
    };

    private onInvestmentSelected(investment, unitCost?) {
        const _investment: Instrument = {
            ...investment,
            ProductCode: investment.ProductCode || investment.InstrumentCode,
            Name: investment.Name || investment.DisplayName,
        };
        InvestmentSelectionAction.getUnitPrice(
            _investment,
            (d) => {
                this.setState({ selectedInvestment: d, isShowDetailModal: true });
            },
            unitCost
        );
    }

    private renderInvestmentDetailPopupModal(): JSX.Element {
        const { isShowDetailModal, selectedInvestment } = this.state;

        if (!isShowDetailModal) return null;
        return (
            <>
                <InvestmentDetailsPopupModal
                    showBox={isShowDetailModal}
                    callBack={() => {
                        this.setState({ isShowDetailModal: false });
                    }}
                    instrumentCode={selectedInvestment?.InstrumentCode}
                    productId={selectedInvestment?.ProductId}
                    instrumentName={selectedInvestment?.DisplayName}
                    unitCost={selectedInvestment?.UnitCost}
                    securityType={selectedInvestment?.Type}
                    unitPrice={selectedInvestment?.UnitPrice}
                />
            </>
        );
    }

    private getTableConfig = (
        process: ProcessType,
        quantityType: OrderType,
        hasLimit,
        valueAtMax: number = 100,
        errorMsgAtMax: string = "value can't exceed 100%"
    ): ITableConfig[] => {

        const allocationTitle = (
            <span>
                Allocation
                <AriaTooltip cssWrapper="is-info-icon ml-6">{fundAllocationTooltip}</AriaTooltip>
             </span>
        );

        return [
        {
                title: "Investment",
                key: "Instrument.DisplayName",
                thCssWrapper: "pl-0",
                tdCssWrapper: "pl-0 pt-28 pb-28",
                toogleOptions: (row, index) => {
                    if (row.isTargetAllocation) {
                        return {
                            toogleable: false,
                        };
                    }
                    if (
                        [
                            ProductType.ManagedModelPortfolio,
                            ProductType.TailoredModelPortfolio,
                            ProductType.AdviserModelPortfolio,
                        ].includes(row.Instrument.Type)
                    ) {
                        return {
                            toogleable: true,
                            onToogle: (isToggle) => this.props.onToggle(isToggle, index, row),
                            isToogle: row.isToggle,
                            expandContent: row.modelPortfolioType ? (
                                <UnderlyingTable
                                    data={row.underlying?.ModelPortfolioProducts}
                                    modelPortfolioType={row.modelPortfolioType}
                                    isTps={row.Instrument.ProductType == ProductType.TailoredModelPortfolio}
                                />
                            ) : (
                                this.targetAllocationTable(row.underlying?.ModelPortfolioProducts)
                            ),
                        };
                    }

                    return {
                        toogleable: false,
                    };
                },
                render: (data, row) => {
                    let label = null;
                    if (
                        [
                            ProductType.ManagedModelPortfolio,
                            ProductType.TailoredModelPortfolio,
                            ProductType.AdviserModelPortfolio,
                        ].includes(row.Instrument.Type)
                    ) {
                        label = <p>{row.Instrument.Name || data}</p>;
                    }
                    else if (row.Instrument?.InstrumentCode == "GBPCash" || row.Instrument?.ProductCode == "GBPCash") {
                        label = <p></p>;
                    }
                    else {
                        label = (
                            <a
                                className="hyperlink"
                                onClick={() =>
                                    this.onInvestmentSelected(
                                        row.Instrument,
                                        this.isSellOrSwitchFrom(process) ? row.Instrument.UnitCost : null
                                    )
                                }
                            >
                                {row.Instrument.Name || data}
                            </a>
                        );
                    }

                    return (
                        <>
                            {label}
                            <p className="mb-0">{row.Instrument.ProductCode || row.Instrument.InstrumentCode}</p>
                            {([ProductType.Equity, ProductType.Bond].includes(row.Instrument.Type) ||
                                [SecurityType.Bond, SecurityType.Share].includes(row.Instrument.Type)) 
                                && row.Instrument.Name != 'GBP Cash' && row.Instrument.DisplayName != 'GBP Cash' &&
                                this.props.excludeLimit != true && (
                                    <RadiosEditor
                                        options={[false, true]}
                                        getText={(o) => (o ? "Limit" : "Market")}
                                        selected={row.isLimit}
                                        disabled={disableInput(row, this.props.process)}
                                        onChange={(v) => {
                                            if (v) {
                                                this.onChangeInvestment(
                                                    {
                                                        isLimit: v,
                                                    },
                                                    row.InstrumentCode
                                                );
                                            } else {
                                                this.onChangeInvestment(
                                                    {
                                                        OrderLimit: null,
                                                        ExpiryDate: JsonDateParser.toDate(addDays(new Date(), 90)),
                                                        isLimit: v,
                                                    },
                                                    row.InstrumentCode
                                                );
                                            }
                                        }}
                                        cssWrapper="rg-inline mb-0"
                                    />
                                )}
                        </>
                    );
                },
            },
            this.isSellOrSwitchFrom(process) && {
                title: "Available units",
                key: "Instrument.CurrQuantity",
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right cell-20 cell-no-break",
                render: (data, row) => {
                    return (
                        <span>
                            {data.toFixed(4)}
                            <AriaTooltip cssWrapper="is-info-icon ml-6">
                                +{row.Instrument.OriginQuantity.toFixed(4)} Holding
                                <br />-{row.Instrument.SellOrders.toFixed(4)} Sell Orders
                                <hr />={(row.Instrument.OriginQuantity - row.Instrument.SellOrders).toFixed(4)}
                            </AriaTooltip>
                        </span>
                    );
                },
            },
            this.isSellOrSwitchFrom(process) && {
                title: "Market value",
                key: "Instrument.MarketValue",
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right cell-20",
                render: (data) => {
                    return MoneyDisplayHelper.getMoneyFormat(data);
                },
            },
            (quantityType == OrderType.Value && !this.isSellOrSwitchFrom(process)) && {
                title: allocationTitle,
                key: "OrderValue",
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right cell-20",
                render: (data, row, index) => {
                    return (
                        <MoneyTextBoxEditor
                            disabled={row.isSellAll || disableInput(row, this.props.process)}
                            value={data}
                            runOnChangeOnUpdateing
                            isFromSell
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "only allow two decimal places",
                                value: 2,
                            }}
                            atMost={
                                (process == ProcessType.Buy && this.state.maxInvestmentInitial > 0) ?
                                    {
                                        value: this.state.maxInvestmentInitial,
                                        errorMessage: "Value cannot exceed the maximum initial investment",
                                    }
                                    :
                                    {
                                        value: this.isSellOrSwitchFrom(process) ? row.Instrument.MarketValue.Amount : (this.isCashProduct(row) ? this.props.depositProducts[row.Instrument.ProductId].MaximumInvestment : 999999999),
                                        errorMessage: "value can not larger than market value",
                                    }
                            }
                            atLeast={
                                (process == ProcessType.Buy && this.state.minInvestmentInitial > 0) ?
                                    {
                                        value: this.state.minInvestmentInitial,
                                        errorMessage: "Value cannot be less than the minimum initial investment",
                                    }
                                    :
                                    {
                                        value: this.isCashProduct(row) ? this.props.depositProducts[row.Instrument.ProductId].MinimumInvestment : 0.01,
                                        errorMessage: "value can not be less than the minimum",
                                    }
                            }
                            cssWrapper="mb-0 control-size-160"
                            infoTextGridClasses="mb-0"
                            currency={CurrencyCode.GBP}
                            onChange={(v) => {
                                if (
                                    this.isSellOrSwitchFrom(this.props.process) &&
                                    v >= row.Instrument.MarketValue.Amount * 0.95 &&
                                    v > 0
                                ) {
                                    if (v < row.Instrument.MarketValue.Amount) {
                                        this.setState({
                                            showOrderAmendedMessage: this.state.showOrderAmendedMessage.concat(index),
                                        });
                                    }
                                    return this.sellAll(true, row.InstrumentCode);
                                } else {
                                    this.setState({
                                        showOrderAmendedMessage: this.state.showOrderAmendedMessage.filter(
                                            (ele) => ele !== index
                                        ),
                                    });
                                }
                                this.onChangeInvestment(
                                    { OrderValue: v, Type: this.props.orderType },
                                    row.InstrumentCode
                                );
                                if (this.props.process == ProcessType.Buy) {
                                    if (row.InstrumentCode) {
                                        InvestmentsAction.getInstrumentDetails(row.InstrumentCode, (val) => {
                                            this.setState({ maxInvestmentInitial: val.MaxInvestmentInitial, minInvestmentInitial: val.MinInvestmentInitial });
                                        });
                                    }
                                }
                            }}
                        />
                    );
                },
            },
            quantityType == OrderType.Percentage && {
                title: process == ProcessType.SwitchFrom ? "Order quantity" : allocationTitle,
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right cell-20",
                key: "OrderPercentage",
                render: (data, row, index) => {
                    if (this.isCashProduct(row) &&
                        this.props.depositProducts[row.Instrument.ProductId] == null) {
                        return <div>Loading...</div>;
                    }
                    return (
                        <PercentageTextBoxEditor
                            disabled={row.isSellAll || disableInput(row, this.props.process) || row.isTargetAllocation}
                            value={data}
                            cssWrapper="mb-0"
                            infoTextGridClasses="text-right text-field-info-mb-0"
                            atMost={
                                !this.isSellOrSwitchFrom(process) && this.isCashProduct(row) ?
                                {
                                    errorMessage: "value can not be more than the maximum",
                                    value: Math.min(valueAtMax, this.props.depositProducts[row.Instrument.ProductId].MaximumInvestment / this.props.totalValue * 100),
                                }
                                :
                                (process == ProcessType.Buy && this.state.maxInvestmentInitial > 0 && (this.state.maxInvestmentInitial / this.props.totalValue) * 100 < valueAtMax) ?
                                {
                                    errorMessage: "Value cannot exceed the maximum initial investment",
                                    value: (this.state.maxInvestmentInitial / this.props.totalValue) * 100,
                                }
                                :
                                {
                                    errorMessage: errorMsgAtMax,
                                    value: valueAtMax,
                                }
                            }
                            runOnChangeOnUpdateing
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "only allow two decimal places",
                                value: 2,
                            }}
                            atLeast={
                                !this.isSellOrSwitchFrom(process) && this.isCashProduct(row) && data !== 0 ?
                                {
                                    errorMessage: "value can not be less than the minimum",
                                    value: Math.max(0, this.props.depositProducts[row.Instrument.ProductId].MinimumInvestment / this.props.totalValue * 100),
                                }
                                :
                                (process == ProcessType.Buy && this.state.minInvestmentInitial > 0) ?
                                {
                                    errorMessage: "Value cannot be less than the minimum initial investment",
                                    value: (this.state.minInvestmentInitial / this.props.totalValue) * 100,
                                }
                                :
                                {
                                    errorMessage: "At least 0%",
                                    value: 0,
                                }
                            }
                            infoText={`${MoneyDisplayHelper.getMoneyFormat({
                                Amount:
                                    this.props.process == ProcessType.Buy
                                        ? this.props.totalValue * this.props.data[index].OrderPercentage * 0.01
                                        : this.props.data[index].Instrument.MarketValue.Amount *
                                          this.props.data[index].OrderPercentage *
                                          0.01,
                                Currency: CurrencyCode.GBP,
                            })}`}
                            onChange={(v) => {
                                if (this.isSellOrSwitchFrom(this.props.process) && v >= 95) {
                                    if (v < 100) {
                                        this.setState({
                                            showOrderAmendedMessage: this.state.showOrderAmendedMessage.concat(index),
                                        });
                                    }
                                    return this.sellAll(true, row.InstrumentCode);
                                } else {
                                    this.setState({
                                        showOrderAmendedMessage: this.state.showOrderAmendedMessage.filter(
                                            (ele) => ele !== index
                                        ),
                                    });
                                }
                                const value =
                                    this.props.process == ProcessType.Buy
                                        ? this.props.totalValue * v * 0.01
                                        : this.props.data[index].Instrument.MarketValue.Amount * v * 0.01;

                                if(this.props.process == ProcessType.Buy) {
                                    if(row.InstrumentCode) {
                                        InvestmentsAction.getInstrumentDetails(row.InstrumentCode, (val) => {
                                            this.setState({ maxInvestmentInitial : val.MaxInvestmentInitial,  minInvestmentInitial : val.MinInvestmentInitial  });
                                        });
                                    }
                                }

                                const quantity = (this.props.process == ProcessType.Sell || this.props.process == ProcessType.SwitchFrom) ? Number(value.toFixed(2))/this.props.data[index].Instrument.UnitPrice?.Amount : null;
                                this.onChangeInvestment(
                                    {
                                        OrderPercentage: v,
                                        Type: this.props.orderType,
                                        OrderValue: Number(value.toFixed(2)),
                                        OrderQuantity: quantity
                                    },
                                    row.InstrumentCode
                                );
                            }}
                        />
                    );
                },
            },
            quantityType == OrderType.Quantity && {
                title: process == ProcessType.Buy ? allocationTitle : "Order quantity",
                key: "OrderQuantity",
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right",
                render: (data, row, index) => {
                    if (this.isCashProduct(row) &&
                        this.props.depositProducts[row.Instrument.ProductId] == null) {
                        return <div>Loading...</div>;
                    }
                    return (
                        <NumberTextBoxEditor
                            value={data}
                            disabled={row.isSellAll || disableInput(row, this.props.process)}
                            cssWrapper="control-size-100 mb-0"
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "only allow four decimal places",
                                value: 4,
                            }}
                            runOnChangeOnUpdateing
                            infoTextGridClasses="text-right text-field-info-mb-0"
                            atMost={
                                this.isSellOrSwitchFrom(process)
                                    ? {
                                          value: row.Instrument.Quantity,
                                          errorMessage: "value can not be larger than available quantity",
                                      }
                                    : (this.isCashProduct(row))
                                        ? {
                                            value: this.props.depositProducts[row.Instrument.ProductId].MaximumInvestment,
                                            errorMessage: "value can not be larger than the maximum quantity",
                                        }
                                        :
                                        (process == ProcessType.Buy && this.state.maxInvestmentInitial > 0 && this.props.data[index].Instrument?.UnitPrice?.Amount > 0) ?
                                            {
                                                value: this.state.maxInvestmentInitial / this.props.data[index].Instrument?.UnitPrice?.Amount,
                                                errorMessage: "Value cannot exceed the maximum initial investment",
                                            }
                                            : null
                            }
                            atLeast={
                                (!this.isSellOrSwitchFrom(process) && this.isCashProduct(row) && data !== 0)
                                    ? {
                                        value: this.props.depositProducts[row.Instrument.ProductId].MinimumInvestment,
                                        errorMessage: "value can not be less than the minimum"
                                    }
                                    :
                                    (process == ProcessType.Buy && this.state.minInvestmentInitial > 0 && this.props.data[index].Instrument?.UnitPrice?.Amount > 0) ?
                                        {
                                            value: this.state.minInvestmentInitial / this.props.data[index].Instrument?.UnitPrice?.Amount,
                                            errorMessage: "Value cannot be less than the minimum initial investment",
                                        }
                                        : null
                            }
                            infoText={`${MoneyDisplayHelper.getMoneyFormat({
                                Amount:
                                    this.props.data[index].Instrument.UnitPrice.Amount *
                                    this.props.data[index].OrderQuantity,
                                Currency: CurrencyCode.GBP,
                            })}`}
                            onChange={(v) => {
                                if (
                                    this.isSellOrSwitchFrom(this.props.process) &&
                                    v >= row.Instrument.Quantity * 0.95
                                ) {
                                    if (v < row.Instrument.Quantity) {
                                        this.setState({
                                            showOrderAmendedMessage: this.state.showOrderAmendedMessage.concat(index),
                                        });
                                    }
                                    return this.sellAll(true, row.InstrumentCode);
                                } else {
                                    this.setState({
                                        showOrderAmendedMessage: this.state.showOrderAmendedMessage.filter(
                                            (ele) => ele !== index
                                        ),
                                    });
                                }
                                const percentage = v/row.Instrument.Quantity*100;
                                this.onChangeInvestment(
                                    {
                                        OrderQuantity: v,
                                        OrderValue:
                                            Number(this.props.data[index].Instrument.UnitPrice.Amount.toFixed(2)) * v,
                                        Type: this.props.orderType,
                                        OrderPercentage: process == ProcessType.Sell || process == ProcessType.SwitchFrom ? percentage : null,
                                    },
                                    row.InstrumentCode
                                );
                                if (this.props.process == ProcessType.Buy) {
                                    if (row.InstrumentCode) {
                                        InvestmentsAction.getInstrumentDetails(row.InstrumentCode, (val) => {
                                            this.setState({ maxInvestmentInitial: val.MaxInvestmentInitial, minInvestmentInitial: val.MinInvestmentInitial });
                                        });
                                    }
                                }
                            }}
                        />
                    );
                },
            },
            (quantityType == OrderType.Value && this.isSellOrSwitchFrom(process)) && {
                title: "Order value",
                key: "OrderValue",
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right cell-20",
                render: (data, row, index) => {
                    return (
                        <MoneyTextBoxEditor
                            disabled={row.isSellAll || this.disableSell(row) || disableInput(row, this.props.process)}
                            value={data}
                            isFromSell
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "only allow two decimal places",
                                value: 2,
                            }}
                            atMost={{
                                value: row.Instrument.MarketValue.Amount,
                                errorMessage: "value can not larger than market value",
                            }}
                            cssWrapper="mb-0 ml-auto control-size-160"
                            infoTextGridClasses="mb-0"
                            currency={CurrencyCode.GBP}
                            onChange={(v) => {
                                if (
                                    this.isSellOrSwitchFrom(this.props.process) &&
                                    v >= row.Instrument.MarketValue.Amount * 0.95 &&
                                    v > 0
                                ) {
                                    if (v < row.Instrument.MarketValue.Amount) {
                                        this.setState({
                                            showOrderAmendedMessage: this.state.showOrderAmendedMessage.concat(index),
                                        });
                                    }
                                    return this.sellAll(true, row.InstrumentCode);
                                } else {
                                    this.setState({
                                        showOrderAmendedMessage: this.state.showOrderAmendedMessage.filter(
                                            (ele) => ele !== index
                                        ),
                                    });
                                }
                                this.onChangeInvestment(
                                    { OrderValue: v, Type: this.props.orderType, OrderQuantity: null, OrderPercentage: null, OrderLimit: row.isLimit ? Number(row.Instrument?.UnitPrice?.Amount.toFixed(2)) : null },
                                    row.InstrumentCode
                                );
                            }}
                        />
                    );
                },
            },
            this.isSellOrSwitchFrom(process) && {
                title: "Order unit",
                key: "OrderQuantity",
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right",
                render: (data, row, index) => {
                    if (this.isCashProduct(row) &&
                        this.props.depositProducts[row.Instrument.ProductId] == null) {
                        return <div>Loading...</div>;
                    }
                    return (
                        <NumberTextBoxEditor
                            value={(row.Instrument && row.Instrument.Type == ProductType.ManagedModelPortfolio) ? null : data }
                            disabled={row.isSellAll || this.disableSell(row) || (row.Instrument && row.Instrument.Type == ProductType.ManagedModelPortfolio) || disableInput(row, this.props.process)}
                            cssWrapper="w-120 ml-auto mb-0"
                            maxNumberOfDecimalPlaces={
                                row.isSellAll 
                                ? undefined
                                : {
                                    errorMessage: "only allow four decimal places",
                                    value: 4,
                                }
                            }
                            infoTextGridClasses="text-right text-field-info-mb-0"
                            atMost={
                                this.isSellOrSwitchFrom(process)
                                    ? {
                                        value: row.Instrument.CurrQuantity.toFixed(4),
                                        errorMessage: "value can not be larger than available quantity",
                                    }
                                    : (this.isCashProduct(row))
                                        ? {
                                            value: this.props.depositProducts[row.Instrument.ProductId].MaximumInvestment,
                                            errorMessage: "value can not be larger than the maximum quantity",
                                        }
                                        : null
                            }
                            atLeast={
                                (!this.isSellOrSwitchFrom(process) && this.isCashProduct(row))
                                ? {
                                        value: this.props.depositProducts[row.Instrument.ProductId].MinimumInvestment,
                                        errorMessage: "value can not be less than the minimum"
                                }
                                : null
                            }
                            onBlur={(v) => {
                                if (v != null) {
                                    this.onChangeInvestment({ OrderQuantity: v.toFixed(4) }, row.InstrumentCode);
                                }
                            }}
                            onChange={(v) => {
                                if (row.OrderQuantity == v||v==null) { return; }
                                else {
                                    if (
                                        this.isSellOrSwitchFrom(this.props.process) &&
                                        v >= row.Instrument.CurrQuantity * 0.95
                                    ) {
                                        if (v < row.Instrument.CurrQuantity) {
                                            this.setState({
                                                showOrderAmendedMessage: this.state.showOrderAmendedMessage.concat(index),
                                            });
                                        }
                                        return this.sellAll(true, row.InstrumentCode);
                                    } else {
                                        this.setState({
                                            showOrderAmendedMessage: this.state.showOrderAmendedMessage.filter(
                                                (ele) => ele !== index
                                            ),
                                        });
                                    }
                                    const percentage = v / row.Instrument.CurrQuantity * 100;
                                    const ordervalue=(this.props.data[index].Instrument.MarketValue.Amount/row.Instrument.CurrQuantity)*v;
                                    this.onChangeInvestment(
                                        {
                                            OrderQuantity: v,
                                            OrderValue:Number(ordervalue.toFixed(2)),
                                            Type: OrderType.Quantity,
                                            OrderPercentage: process == ProcessType.Sell || process == ProcessType.SwitchFrom ? percentage.toFixed(4) : null,
                                            OrderLimit: row.isLimit ? Number(row.Instrument?.UnitPrice?.Amount.toFixed(2)):null

                                        },
                                        row.InstrumentCode
                                    );
                                }
                            }}
                        />
                    );
                },
            },
            this.isSellOrSwitchFrom(process) && {
                title: "Allocation",
                key: "OrderPercentage",
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right cell-20",
                render: (data, row, index) => {
                    if (this.isCashProduct(row) &&
                        this.props.depositProducts[row.Instrument.ProductId] == null) {
                        return <div>Loading...</div>;
                    }
                    return (
                        <PercentageTextBoxEditor
                            disabled={
                                (this.props.data.length == 1
                                ? row.isSellAll || (row.OrderValue != null && row.OrderValue >= row.Instrument.MarketValue.Amount) || row.isTargetAllocation
                                : row.isSellAll || this.disableSell(row) || row.isTargetAllocation) || disableInput(row, this.props.process)
                            }                            
                            value={data}
                            cssWrapper="mb-0 w-100 ml-auto"
                            infoTextGridClasses="text-right text-field-info-mb-0"
                            atMost={
                                !this.isSellOrSwitchFrom(process) && this.isCashProduct(row) ?
                                {
                                    errorMessage: "value can not be more than the maximum",
                                    value: Math.min(valueAtMax, this.props.depositProducts[row.Instrument.ProductId].MaximumInvestment / this.props.totalValue * 100),
                                }
                                :
                                {
                                errorMessage: errorMsgAtMax,
                                value: valueAtMax,
                                }
                            }
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "only allow four decimal places",
                                value: 4,
                            }}
                            atLeast={
                                !this.isSellOrSwitchFrom(process) && this.isCashProduct(row) ?
                                {
                                    errorMessage: "value can not be less than the minimum",
                                    value: Math.max(0, this.props.depositProducts[row.Instrument.ProductId].MinimumInvestment / this.props.totalValue * 100),
                                }
                                :
                                {
                                errorMessage: "At least 0%",
                                value: 0,
                                }
                            }
                            onChange={(v) => {
                                if (row.OrderPercentage == v||v==null) { return; }
                                else {
                                    if (this.isSellOrSwitchFrom(this.props.process) && v >= 95) {
                                        if (v < 100) {
                                            this.setState({
                                                showOrderAmendedMessage: this.state.showOrderAmendedMessage.concat(index),
                                            });
                                        }
                                        return this.sellAll(true, row.InstrumentCode);
                                    } else {
                                        this.setState({
                                            showOrderAmendedMessage: this.state.showOrderAmendedMessage.filter(
                                                (ele) => ele !== index
                                            ),
                                        });
                                    }
                                    const value =
                                        this.props.process == ProcessType.Buy
                                            ? this.props.totalValue * v * 0.01
                                            : this.props.data[index].Instrument.MarketValue.Amount * v * 0.01;
                                    const quantity = (this.props.process == ProcessType.Sell || this.props.process == ProcessType.SwitchFrom) ? Number(value.toFixed(2)) / this.props.data[index].Instrument.UnitPrice?.Amount : null;
                                    this.onChangeInvestment(
                                        {
                                            OrderPercentage: v,
                                            Type: OrderType.Quantity,
                                            OrderValue: Number(value.toFixed(2)),
                                            OrderQuantity: Number(quantity.toFixed(4)),
                                            OrderLimit: row.isLimit ? Number(row.Instrument?.UnitPrice?.Amount.toFixed(2)) : null
                                        },
                                        row.InstrumentCode
                                    );
                                }
                            }}
                        />
                    );
                },
            },
            hasLimit && {
                title: "Limit",
                key: "OrderLimit",
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right cell-20",
                render: (data, row) => {
                    if (
                        ![ProductType.Equity, ProductType.Bond].includes(row.Instrument.Type) &&
                        ![SecurityType.Bond, SecurityType.Share].includes(row.Instrument.Type)
                    ) {
                        return null;
                    }
                    if (!row.isLimit) return null;
                    return (
                        <MoneyTextBoxEditor
                            value={data}
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "only allow two decimal places",
                                value: 2,
                            }}
                            cssWrapper="mb-0 ml-auto control-size-160"
                            currency={CurrencyCode.GBP}
                            onChange={(v) => {
                                const orderType = this.getOrderType(row);
                                this.onChangeInvestment(
                                    { OrderLimit: v, Type: orderType },
                                    row.InstrumentCode
                                );
                            }}                          
                        />
                    );
                },
            },
            hasLimit && {
                title: "Expiry Date",
                key: "ExpiryDate",
                thCssWrapper: "cell-right cell-20",
                tdCssWrapper: "cell-right cell-20",
                render: (data, row) => {
                    if (
                        ![ProductType.Equity, ProductType.Bond].includes(row.Instrument.Type) &&
                        ![SecurityType.Bond, SecurityType.Share].includes(row.Instrument.Type)
                    ) {
                        return null;
                    }
                    if (!row.isLimit) return null;
                    return (
                        <DatePicker
                            label=""
                            selected={JsonDateParser.toDateNoOffset(data)}
                            onChange={(v) =>
                                this.onChangeInvestment(
                                    { ExpiryDate: JsonDateParser.toJsonDateNoOffset(v) },
                                    row.InstrumentCode
                                )
                            }
                            {...datePickerOptions}
                            required="Please enter"
                            atLeast={{
                                value: new Date(),
                                errorMessage: ContentDatePicker.CannotBeInThePast,
                            }}
                            atMost={{
                                value: addDays(new Date(), 90),
                                errorMessage: "The maximum expiry date is 90 days",
                            }}                            
                            formGroupCssWrapper="mb-0"
                            cssWrapper="calendar-is-right-aligned"
                        />
                    );
                },
            },
            process == ProcessType.Buy && {
                title: "Action",
                key: "Action",
                thCssWrapper: "cell-right cell-20 pr-0",
                tdCssWrapper: "cell-right cell-20 pr-0",
                render: (data, row) => {
                    if (row.Instrument.DisplayName == "GBP Cash") return null;
                    return (
                        <button
                            className="remove-button label-sr-only"
                            title="Delete"
                            onClick={() => this.onChangeInvestment(-1, row.InstrumentCode, true)}
                        >
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">remove portfolio</span>
                        </button>
                    );
                },
            },
            this.isSellOrSwitchFrom(process) && {
                thCssWrapper: "cell-right pr-0",
                tdCssWrapper: "cell-right pr-0",
                title: (
                    <span>
                        {process == ProcessType.SwitchFrom ? "Switch all" : "Sell all"}
                        <AriaTooltip cssWrapper="is-info-icon ml-6">{sellAllTooltip}</AriaTooltip>
                    </span>
                ),
                key: "isSellAll",
                render: (data, row, index) => {
                    return (
                        <CheckboxEditor
                            cssWrapper={"square-checkbox mb-0"}
                            onChange={(v) => {
                                if (!v) {
                                    this.setState({
                                        showOrderAmendedMessage: this.state.showOrderAmendedMessage.filter(
                                            (ele) => ele != index
                                        ),
                                    });
                                }
                                this.sellAll(v, row.InstrumentCode);
                            }}
                            value={data}
                            disabled={disableInput(row, this.props.process, false)}
                        />
                    );
                },
            },
            this.isSellOrSwitchFrom(process) &&
                SubAccountTypeHelper.isPPAndISA(
                    ClientAccountStore.getClientAccountInfo()?.SubAccounts?.find(
                        (ele) => ele.HierarchyId == getQueryParameters()?.["subaccounthierarchyid"]
                    )?.SubAccountType
                ) && {
                    thCssWrapper: "cell-right pr-0",
                    tdCssWrapper: "cell-right pr-0",
                    title: (
                        <span>
                            Protect?
                            <AriaTooltip cssWrapper="is-info-icon ml-6">{treasureAssetTooltip}</AriaTooltip>
                        </span>
                    ),
                    key: "isTreasuredAsset",
                    render: (data, row) => {
                        if (row.Instrument.Name == "GBP Cash") return null;
                        else if (row.InstrumentCode !== GBPInvestmentCode && row.Instrument.Type != ProductType.CashProduct) {
                            return (
                                <CheckboxEditor
                                    cssWrapper={"square-checkbox mb-0"}
                                    onChange={function () {}}
                                    value={this.props.ChecktreasuredAsset?.includes(row.Instrument.ProductId)}
                                    disabled={true}
                                />
                            );
                        } else {
                            return <td className="cell-center">-</td>;
                        }
                    },
                },
            process == (ProcessType.Buy || ProcessType.SwitchTo) &&
            !SubAccountTypeHelper.isLegacyProduct(
                ClientAccountStore.getClientAccountInfo()?.SubAccounts?.find(
                    (ele) => ele.HierarchyId == getQueryParameters()?.["subaccounthierarchyid"]
                )?.SubAccountType
            ) &&
            ClientAccountStore.getClientAccountInfo()?.AccountServicePropositionId == ServiceProposition.Wrap
                ? {
                      thCssWrapper: "cell-right pr-0",
                      tdCssWrapper: "cell-right pr-0",
                      title: (
                          <span>
                              Protect?
                              <AriaTooltip cssWrapper="is-info-icon ml-6">{treasureAssetTooltip}</AriaTooltip>
                          </span>
                      ),
                      key: "isTreasuredAsset",
                      render: (data, row) => {
                        if (row.Instrument.Type != ProductType.CashProduct) {
                            return (

                                <CheckboxEditor
                                    cssWrapper={"square-checkbox mb-0"}
                                    onChange={(v) => this.treasureAsset(v, row.InstrumentCode)}
                                    value={this.props.ChecktreasuredAsset?.includes(row.Instrument.ProductId)}
                                    disabled={(TreasuredAssetsStore.getTreasuredAssetsProductIds() || [])?.includes(
                                        row.Instrument.ProductId
                                    )}
                                />
                            );
                        } else {
                            return (
                                <span>N/A</span>
                            );
                        }
                      },
                  }
                : null,
        ].filter((ele) => ele != null);
    };

    private renderTbody(data: any[], indexAlert, colConfig, colConfigLast) {
        let rowIndex = 0;
        if (!data || data.length == 0)
            return (
                <tbody>
                    <tr>
                        <td colSpan={colConfig.length}>
                            <Alert
                                cssWrapper={"mb-0"}
                                alertType={AlertType.Warning}
                                message={"No investments have been selected."}
                            />
                        </td>
                    </tr>
                </tbody>
            );
        const tBody: JSX.Element[] = [];
        data.map((ele, index) => {
            tBody.push(
                <TableRow
                    key={`table-row-${rowIndex}`}
                    col={index === indexAlert ? colConfigLast : colConfig}
                    data={ele}
                    index={rowIndex}
                    tdCssWrapper="pl-0"
                />
            );
            rowIndex = rowIndex + 1;
        });
        return <tbody>{tBody}</tbody>;
    }

    private renderTotal(data) {
        const { orderType, process } = this.props;
        const totalValue = {
            Amount: data
                ? data.reduce((sum, curr) => (sum = Number((sum + (Number(curr.OrderValue) || 0)).toFixed(2))), 0)
                : 0,
            Currency: CurrencyCode.GBP,
        };
        if (this.isSellOrSwitchFrom(process)) return <span>{MoneyDisplayHelper.getMoneyFormat(totalValue)}</span>;
        if (orderType == OrderType.Percentage) {
            const total = data
                ? data.reduce((sum, curr) => (sum = Number((sum + (Number(curr.OrderPercentage) || 0)).toFixed(2))), 0)
                : 0;
            const totalValueFromPercentage = this.props.totalValue * total * 0.01;
            return (
                <>
                    <span className={total == "100" ? "text-positive" : "text-text"}>{total}%</span>
                    <br />
                    <span className="text-text">{MoneyDisplayHelper.getMoneyFormat({Amount: totalValueFromPercentage, Currency: CurrencyCode.GBP})}</span>
                </>
            );
        }
        if (orderType == OrderType.Quantity) {
            const total = data ? data.reduce((sum, curr) => (sum = sum + (curr.OrderQuantity || 0)), 0) : 0;
            return (
                <>
                    {total}
                    <br />
                    {MoneyDisplayHelper.getMoneyFormat(totalValue)}
                </>
            );
        }
        return <>{MoneyDisplayHelper.getMoneyFormat(totalValue)}</>;
    }

    public render(): JSX.Element {
        const { data, process, orderType, excludeLimit } = this.props;
        const hasExchangeTraded = excludeLimit == true ? false : data && data.some((ele) => ele.isLimit) ? true : false;
        let colConfig = this.getTableConfig(process, orderType, hasExchangeTraded);
        colConfig = colConfig.filter((ele) => typeof ele !== "boolean");

        let totalPrecentage = 0;
        let indexAlert = data.length;
        if (process === ProcessType.Buy) {
            for (let i = 0; i < data.length; i++) {
                totalPrecentage =
                    MoneyHelper.roundNumberToDecimalPlaces(totalPrecentage + (data[i].OrderPercentage ? Number(data[i].OrderPercentage.toFixed(2)) : 0),2);
                if (totalPrecentage > 100) {
                    indexAlert = i;
                    break;
                }
            }
        }
        const errorMsgAtMax = "Total allocation can't exceed 100%";
        const colConfigLast = this.getTableConfig(process, orderType, hasExchangeTraded, 0, errorMsgAtMax).filter(
            (ele) => typeof ele !== "boolean"
        );
        return (
            <>
                {this.state.showOrderAmendedMessage.length > 0 && (
                    <Alert alertType={AlertType.Warning} message={orderAmendedMsg} />
                )}
                
                <div className="table-scrollable overflow-y-auto mb-40">
                    <table className="data-table no-sided-padding is-allocation-table table-expandable is-compact">
                        <TableHeader col={colConfig} />
                        {this.renderTbody(data, indexAlert, colConfig, colConfigLast)}
                        <tfoot>
                            <tr className="total cells-right">
                                <td colSpan={this.isSellOrSwitchFrom(process) ? 3 : 1}>
                                    {this.isSellOrSwitchFrom(process) ? "Estimated total to sell" : "Total"}
                                </td>
                                <td colSpan={hasExchangeTraded ? 3 : 1}>{this.renderTotal(data)}</td>
                                <td colSpan={hasExchangeTraded ? 1 : 3}>
                                    {process == ProcessType.Buy ? (
                                        <button
                                            className="remove-button label-sr-only"
                                            title="Delete"
                                            onClick={() => this.props.onChange([])}
                                        >
                                            <span className="icon" aria-hidden="true"></span>
                                            <span className="text">Remove all porfolios</span>
                                        </button>
                                    ) : null}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                {this.renderInvestmentDetailPopupModal()}
            </>
        );
    }
}
